import * as React from 'react';
import { IMagazinePageSection } from 'models/common/section';
import { ISectionImageElement } from 'models/common/sectionimageelement';
import { ISectionTextElement } from 'models/common/sectiontextelement';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { default as Slider } from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Link } from 'react-router';
require('./style.css');

interface IProps {
	section: IMagazinePageSection;
	t?: (key: string) => string;
}

function CustomSlickArrow(props) {
	const { classToAdd, label, onClick } = props;

	return (
		<button className={classToAdd} onClick={onClick}>
			{label}
		</button>
	);
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ViewType3 extends React.Component<IProps, any> {
	constructor(props) {
		super(props);
	}

	public componentDidMount() {
		const timer = document.getElementsByClassName('sliderTimer');
		let i = timer.length;
		while (i--) {
			timer[i].classList.add('active');
		}
	}

	public render() {
		const { elements } = this.props.section.data;
		const { t } = this.props;

		const settings = {
			dots: true,
			infinite: true,
			speed: 674,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			dotsClass: 'type3dots',
			nextArrow: <CustomSlickArrow classToAdd="customNext" label={t('BSPortal_Common_Next')} />,
			prevArrow: <CustomSlickArrow classToAdd="customPrev" label={t('BSPortal_Common_Previous')} />,
			autoplay: true,
			autoplaySpeed: 5200,
			pauseOnHover: false,
			easing: 'cubic-bezier(0.4, 0.0, 0.25, 0.9)',
			responsive: [
				{
					breakpoint: 992,
					settings: {
						dots: true,
						infinite: true,
						speed: 674,
						slidesToShow: 1,
						slidesToScroll: 1,
						arrows: false,
						dotsClass: 'type3dots',
						autoplay: false,
						easing: 'cubic-bezier(0.4, 0.0, 0.25, 0.9)',
					},
				},
			],
		};

		const elementsContent: JSX.Element[] = [];
		elements.map((element, index) => {
			if (index === 1 || index === 6 || index === 11) {
				if ((element as ISectionImageElement).imageUrl) {
					elementsContent.push(
						<div key={'section3_slide' + index} className="singleSlide">
							<div className="slideHolder">
								<Link className="leftImage" to={(elements[index - 1] as ISectionImageElement).redirectUrl}>
									<span style={{ backgroundImage: `url(${(elements[index - 1] as ISectionImageElement).imageUrl})` }} />
								</Link>
								<Link className="mainImageHolder" to={(elements[index] as ISectionImageElement).redirectUrl}>
									<span
										className="mainImage"
										style={{ backgroundImage: `url(${(elements[index] as ISectionImageElement).imageUrl})` }}
									>
										<span className="mainText">{(elements[index + 1] as ISectionTextElement).text}</span>
										<span className="author">
											<span className="byText">{t('Magazine_Section_Common_By')} </span>
											<span className="text">{(elements[index + 2] as ISectionTextElement).text}</span>
										</span>
									</span>
								</Link>
								<Link className="rightImage" to={(elements[index + 3] as ISectionImageElement).redirectUrl}>
									<span style={{ backgroundImage: `url(${(elements[index + 3] as ISectionImageElement).imageUrl})` }} />
								</Link>
								<div className="sliderTimer" />
							</div>
						</div>,
					);
				}
			}
		});

		return (
			<div className="container sectionType3container">
				<div className="row">
					<div className="col-md-12 type3mobilePadFix">
						<Slider {...settings}>{elementsContent}</Slider>
					</div>
				</div>
			</div>
		);
	}
}

export { ViewType3 };
